import React from "react";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const ArticleSeparator = ({ gapBottom = false, marginoff = false }) => (
	<>
		<div
			style={{
				marginTop: "0",
				textAlign: "center",
				marginBottom: gapBottom ? "20px" : 0,
			}}
		>
			<hr
				style={{
					color: "grey",
					backgroundColor: "grey",
					height: 0,
					margin: !marginoff ? "0px 40px 0px 40px" : 0,
					marginTop: 0,
					border: "1px solid #DEDEDE",
				}}
			/>
		</div>
	</>
);
